function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".notificationa{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.891, 0.454, -0.454, 0.891, -175.672, -3876.715)"
}, /*#__PURE__*/React.createElement("path", {
  className: "notificationa",
  d: "M1956.229,3395.321h-27.762a1.3,1.3,0,0,1-.443-2.527c1.958-.712,2.209-1.576,2.209-2.25v-6.558a12.149,12.149,0,0,1,7.246-11.331,5.111,5.111,0,0,1,4.868-3.655,5.035,5.035,0,0,1,4.866,3.656,12.15,12.15,0,0,1,7.249,11.33v6.558c0,.674.251,1.538,2.21,2.25a1.3,1.3,0,0,1-.443,2.527Zm-.314-.443h0Zm-24.37-1.772h21.605a3.871,3.871,0,0,1-.9-2.561v-6.558a9.929,9.929,0,0,0-6.373-9.48,1.107,1.107,0,0,1-.709-.87,2.836,2.836,0,0,0-2.816-2.419,2.873,2.873,0,0,0-2.821,2.419,1.108,1.108,0,0,1-.709.87,9.928,9.928,0,0,0-6.368,9.48v6.558A3.874,3.874,0,0,1,1931.545,3393.1Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "notificationa",
  d: "M1958.811,3441.183a5.5,5.5,0,0,1-5.541-5.813,1.108,1.108,0,0,1,2.216,0,3.335,3.335,0,1,0,6.65,0,1.108,1.108,0,0,1,2.216,0A5.558,5.558,0,0,1,1958.811,3441.183Z",
  transform: "translate(-16.464 -41.157)"
}));

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.006,
    height: 37.238,
    viewBox: "0 0 39.006 37.238",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.9a8d9632.svg";
export { ForwardRef as ReactComponent };